import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeRegistrationCancelFormView1({
  isBeforePayment,
  paymentAmount,
  shouldRefundOnCancellation,
  isAvailableOnNextone,
  onNext,
} : {
  isBeforePayment: boolean,
  paymentAmount: number,
  shouldRefundOnCancellation: boolean,
  isAvailableOnNextone: boolean,
  onNext: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);

  return (
    <form>
      <div className="form__body">
        <dl>
          <dd>
            {!isBeforePayment && !shouldRefundOnCancellation && (
              <CustomCheckbox
                checked={agreement1}
                setChecked={(checked) => setAgreement1(checked)}
              >
                {!isAvailableOnNextone && 'このお申し込みで締結した契約をすべて破棄します。'}
                {isAvailableOnNextone && '著作権譲渡契約を解除し、NexToneへの著作権管理委託を終了します。'}
              </CustomCheckbox>
            )}
            <CustomCheckbox
              checked={agreement2}
              setChecked={(checked) => setAgreement2(checked)}
            >
              {isBeforePayment && `変更後の料金${CurrencyUtility.format(paymentAmount - 5000)}円を銀行振込で支払います。`}
              {!isBeforePayment && shouldRefundOnCancellation && 'プランの差額5,000円は、5営業日以内にFrekul残高で返金されます。'}
              {!isBeforePayment && !shouldRefundOnCancellation && !isAvailableOnNextone && '手続きが進行しているため、プランの差額5,000円は返金されません。'}
              {!isBeforePayment && !shouldRefundOnCancellation && isAvailableOnNextone && '申込み時の手数料等は一切返金されません。'}
            </CustomCheckbox>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="default" disabled={!(((!isBeforePayment && !shouldRefundOnCancellation) || agreement1) && agreement2)} onClick={() => onNext()}>同意して変更</CustomButton>
          </li>
        </ul>
      </div>
    </form>
  );
}
